import React from 'react';

export default function StatusBadge({ status, map }) {
  const cls = map?.[status] || 'secondary';
  return <span className={`badge badge-${cls}`}>{status?.replace(/-/g, ' ').toUpperCase()}</span>;
}